var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyNurse8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H64C72.8366 0 80 7.16344 80 16V64C80 72.8366 72.8366 80 64 80H16C7.16344 80 0 72.8366 0 64V16Z",
    fill: "#FEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0566 53.0286V55.2001C28.0566 55.4878 28.1707 55.7646 28.3747 55.9677C28.5778 56.1718 28.8546 56.2857 29.1424 56.2857H50.8567C51.1444 56.2857 51.4212 56.1718 51.6243 55.9677C51.8284 55.7646 51.9423 55.4878 51.9423 55.2001V53.0286C51.9423 49.8616 50.684 46.8238 48.4442 44.584C46.2044 42.3441 43.1665 41.0858 39.9995 41.0858C36.8325 41.0858 33.7947 42.3441 31.5548 44.584C29.315 46.8238 28.0566 49.8616 28.0566 53.0286Z",
    fill: "#E95454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.285 56.2857H26.0717C25.949 55.9404 25.8849 55.5735 25.8849 55.2V53.0285C25.8849 50.5488 26.5374 48.1363 27.7469 46.0213C26.8404 45.6392 25.8448 45.4286 24.7992 45.4286C20.6019 45.4286 17.1992 48.8312 17.1992 53.0285V55.2C17.1992 55.7993 17.6856 56.2857 18.285 56.2857Z",
    fill: "#E95454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1997 45.4286C54.1541 45.4286 53.1585 45.6392 52.252 46.0213C53.4614 48.1363 54.1139 50.5488 54.1139 53.0285V55.2C54.1139 55.5735 54.0498 55.9404 53.9272 56.2857H61.7139C62.3133 56.2857 62.7996 55.7993 62.7996 55.2V53.0285C62.7996 48.8312 59.397 45.4286 55.1997 45.4286Z",
    fill: "#E95454"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5927 41.7123C30.7332 39.6137 30.7672 36.1772 28.6687 34.0367C26.5701 31.8961 23.1336 31.8621 20.993 33.9607C18.8525 36.0593 18.8184 39.4958 20.917 41.6363C23.0156 43.7769 26.4521 43.8109 28.5927 41.7123Z",
    fill: "#E95454"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9999 41.7238C61.1407 39.625 61.1747 36.1882 59.0759 34.0475C56.9772 31.9067 53.5403 31.8727 51.3996 33.9714C49.2589 36.0702 49.2248 39.507 51.3236 41.6478C53.4224 43.7885 56.8592 43.8225 58.9999 41.7238Z",
    fill: "#E95454"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2029 38.8079C45.3457 38.1405 48.163 34.2412 47.4956 30.0985C46.8282 25.9557 42.9289 23.1384 38.7862 23.8058C34.6435 24.4732 31.8262 28.3725 32.4935 32.5152C33.1609 36.6579 37.0602 39.4752 41.2029 38.8079Z",
    fill: "#E95454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyNurse8);
export default __webpack_public_path__ + "static/media/whyNurse8.554db351ed4a49f014e8141a2ab5aba2.svg";
export { ForwardRef as ReactComponent };